import { render, staticRenderFns } from "./AlertMessages.vue?vue&type=template&id=013ffb2b"
import script from "./AlertMessages.vue?vue&type=script&lang=js"
export * from "./AlertMessages.vue?vue&type=script&lang=js"
import style0 from "./AlertMessages.vue?vue&type=style&index=0&id=013ffb2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports